const GeneralSettings = () => import('./GeneralSettings.vue')
const Integrations = () => import('./Integrations.vue')

export default [
  {
    name: 'admin',
    path: '/',
    component: GeneralSettings,
    meta: {
      access: ['org.settings.manage', 'org.settings.general.manage']
    }
  },
  {
    name: 'general-settings',
    path: 'general-settings',
    component: GeneralSettings,
    meta: {
      access: ['org.settings.manage', 'org.settings.general.manage']
    }
  },
  {
    name: 'integrations',
    path: 'integrations',
    component: Integrations,
    meta: {
      access: ['org.settings.manage', 'org.settings.integration.manage']
    }
  }
]
